export default "__VITE_ASSET__6c998670__"